export default __webpack_public_path__ + "static/media/edit-pencil.ea533104.svg";